import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextBoolean from "components/text/TextBoolean";
import TextAmount from 'components/text/TextAmount';
import TextPercent from 'components/text/TextPercent';
import TextNumber from 'components/text/TextNumber';
import TransactionKey from 'calculator/components/TransactionKey';
import TextCalculatedFor from 'calculator/components/TextCalculatedFor';


const ReturnResultList = ({ data }) => {    
    if (!data){
      return (
        <div/>
      );
    }
    
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="2" className="text-left">
              <span className="calc-setting-table-header">Útreiknuð skil miðað við innborganir</span>
            </th>
          </tr>
          <tr>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Staða</th>
          </tr>
          </thead>
          <tbody>
          {data.map((item,i) => {
            return(
              <tr key={i}>
                <td className="text-left"> <TransactionKey data={item.transactionKey}/></td>
                <td className="text-right"><TextAmount value={item.amount}/></td>
              </tr>)
          })}
          </tbody>
        </table>
      </div>
    );  
}

ReturnResultList.propTypes = {
  data: PropTypes.array,
};



export default ReturnResultList;
